/**
 * @author: lv.chen
 * @desc: IndustryNews行业新闻
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';
import EllipsisHover from '@home/components/EllipsisHover';
import { getSanitizeHTMLString } from '@intelligence/v3/utils/common';
import { CasualDailyReportData, getTagColor } from '@intelligence/v3/pages/CasualDailyReports/utils';

interface IIndustryNewsProps extends IBaseProps {
  markdownConverter: React.MutableRefObject<CasualDailyReportData>;
  renderLinker: any;
  industryNews?: IIndustryNews[] | null;
}

const IndustryNews: React.FC<IIndustryNewsProps> = (props) => {
  const { style, className, markdownConverter, renderLinker, industryNews } = props;
  const industryNewsLength = industryNews?.length || 0;

  return (
    <div
      style={style}
      className={classnames('dbi-section-industry-news dbi-casual-daily-reports-industry-news', className, {
        'dbi--more': industryNewsLength > 1,
      })}
    >
      <div className="dbi-section-industry-news-title"></div>
      <div className="dbi-section-industry-news-content">
        {industryNews?.map((item, index) => {
          const itemTag = item?.tag || '';
          const itemIsSpecial = item?.is_special || false;

          return (
            <div key={index} className="dbi-industry-news-card">
              {itemIsSpecial && <i className="dbi-icon-featured"></i>}
              <div className="dbi-card-content">
                <div className={classnames('dbi-tag', `dbi-tag-color-${getTagColor(itemTag)}`)}>{itemTag}</div>
                <EllipsisHover className="dbi-title" text={item?.title} />
                <div
                  className="dbi-content"
                  dangerouslySetInnerHTML={{
                    __html: markdownConverter.current.convertMarkdownToHTMLWithStyle(
                      getSanitizeHTMLString(item?.abstract) || '',
                      {
                        h3: '',
                        ul: '',
                        li: '',
                      },
                    ),
                  }}
                ></div>
                {renderLinker(item)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IndustryNews;
